var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-toggle',{attrs:{"value":_vm.isDelivery,"data":_vm.setDeliveryDetails},on:{"input":_vm.setDelivery}})}
var staticRenderFns = []

export { render, staticRenderFns }